import React, { useRef, useState, useEffect } from "react";
import { message } from "antd";
import { YHDrawer } from "@/components/YhDrawer";
import { FormItemTypeEnum, IYhForm, IYhFormRef, ISelectOption } from "@/components/YhFormBox/Types";
import { YhForm } from "@/components/YhFormBox";
import { getFormValidatorErrText } from "@/utils/utils";
import { useWarehouseDetailModel } from "./warehouseDetailModel";
import { IPositionFormFields } from "../../warehouseService";

//货位
export function PositionDrawer() {
    const {
        positionDrawer: { visible, mode },
        editFormVal,
        selectedPositionRows,
        setIpositionDrawer,
        insertPosition,
        batchInserttPosition,
        updatePosition
    } = useWarehouseDetailModel();
    const formRef = useRef<IYhFormRef>();
    const [isBatch, setIsBatch] = useState<boolean>(true);

    //监听批量录入字段
    const onChange = (changedValues: { [key: string]: any }) => {
        if ('isBatch' in changedValues) {
            setIsBatch(!changedValues['isBatch']);
        }
    }
    
    const onCancel = () => {
        setIpositionDrawer();
    }

    useEffect(() => {
        !isBatch && formRef.current?.setFieldsValue({ code: null, name: null });
    }, [isBatch]);

    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then(val => {
            let data = {
                ...val,
                code: val.code?.trim()
            }
            if (mode === "edit") {
                updatePosition(data)
            } else {
                isBatch ? insertPosition(data) : batchInserttPosition(data);
            }
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    const formConfig: IYhForm<IPositionFormFields> = {
        formRef,
        formValues: mode === "edit" ? selectedPositionRows[0] : { warehouseName: editFormVal.name, isBatch: !isBatch },
        labelCol: { span: 6 },
        onChange,
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "所属仓库",
                fieldName: "warehouseName",
                span: 24,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "货位编码",
                fieldName: "code",
                span: 24,
                disable: !isBatch || mode === "edit",
                rules: [{ required: isBatch, message: "请输入货位编码" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "起始编码",
                fieldName: "startCode",
                span: 24,
                hidden: isBatch,
                rules: [{ required: !isBatch, message: "请输入起始编码" }, { pattern: /^[0-9]*$/, message: "请输入数值类型" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "数量",
                fieldName: "num",
                span: 24,
                hidden: isBatch,
                rules: [{ required: !isBatch, message: "请输入数量" }, { pattern: /^[0-9]*$/, message: "请输入数值类型" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "前缀",
                fieldName: "prefix",
                span: 24,
                hidden: isBatch,
                rules: [{ required: !isBatch, message: "请输入前缀" }]
            }, {
                type: FormItemTypeEnum.Checkbox,
                fieldLabel: "批量录入",
                fieldName: "isBatch",
                span: 24,
                hidden: mode === "edit" ? true : false
            }
        ]
    };
    return (
        <YHDrawer
            {...{
                title: `货位${mode === "edit" ? "编辑" : "新增"}`,
                visible,
                onCancel,
                okText: "保存",
                onOk: onSubmit
            }}
        >
            <YhForm {...formConfig} />
        </YHDrawer>
    )
}
